import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {OrganizationUnitModel} from '../../../../models/OrganizationUnitModel';
import {OrganizationUnitAnagrafService} from '../../../general-services/service-organization-unit-anagraf/organization-unit-anagraf.service';

@Component({
  selector: 'app-new-organization-unit-anagraf',
  templateUrl: './new-organization-unit-anagraf.component.html',
  styleUrls: ['./new-organization-unit-anagraf.component.scss']
})
export class NewOrganizationUnitAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {
  organizationUnit: OrganizationUnitModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;
  submitted = false;
  constructor(private route: ActivatedRoute, private router: Router,
              private organizationUnitService: OrganizationUnitAnagrafService) {
    super();

    this.organizationUnit = new OrganizationUnitModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.organizationUnit.cod, [Validators.required]],
      description: [this.organizationUnit.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
  //  this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.ORGANIZATION_UNIT_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    this.submitted = true;
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.organizationUnit.cod = this.formValidator.value.cod;
      this.organizationUnit.description = this.formValidator.value.description;
      this.saveSubscribe = this.organizationUnitService.save(this.organizationUnitService.baseUrl, this.organizationUnit).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Organization Unit Cod already exists', 'Warning');
          } else {
            toastr.success('Organization Unit was added with success', 'Success');
            //     this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.ORGANIZATION_UNIT_ANAGRF]);
          }
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get fv() { return this.formValidator.controls; }

}
